import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberFormatPipe } from 'src/app/shared/pipes';

@Component({
  selector: 'app-clients-rating',
  standalone: true,
  imports: [CommonModule, NumberFormatPipe],
  templateUrl: './clients-rating.component.html',
  styleUrls: ['./clients-rating.component.scss'],
})
export class ClientsRatingComponent implements OnInit {
  // inputs
  @Input() rate: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
